import React from "react";
import Arrow from "./Arrow";
import Newsletter from "./Newsletter";
import Sitemap from "./Sitemap";

interface FooterProps {
  isLoggedIn: boolean;
}

const Footer = (props: FooterProps) => {
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="relative">
      <button
        style={{ width: "26px", height: "26px" }}
        data-testid="scroll-top"
        className="rounded-full border-1 border-grey-400 absolute top-[18px] right-[16px] lg:top-[57px] lg:right-[42px] flex justify-center items-center"
        onClick={scrollTop}
      >
        <Arrow />
      </button>

      <section className="p-20 lg:px-[70px] lg:pt-[57px] lg:pb-[103px] grid grid-areas-mobile-footer grid-cols-1 lg:grid-areas-desktop-footer lg:grid-cols-2">
        <div className="grid-in-about">
          {/* @ts-ignore */}
          {window && window.WANTABLE_footer.logo && (
            // @ts-ignore
            <img
              className="h-[36px]"
              src={
                //@ts-ignore
                window.WANTABLE_footer.logo
              }
              alt="wantable logo"
            />
          )}

          {window && (
            <p className="w-full mt-[23px] text-mobile-body md:text-desktop-body font-medium w-[459px] font-secondary">
              {/* @ts-ignore */}
              {window.WANTABLE_footer.description}
            </p>
          )}
        </div>

        <Newsletter />

        <Sitemap />
      </section>
    </footer>
  );
};

export default Footer;
